import * as React from "react";
const SvgCard = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.667 2.667h14.666v2.666H.667V2.667Zm0 4.666h14.666v6H.667v-6Z", fill: "#000" }));
export default SvgCard;
